import {Endpoint} from '@eryxcoop/appyx-comm';

export default class EditOrdersObservationsEndpoint extends Endpoint {
  adaptValues({orderNumber, observations}) {
    return {
      "order_number": orderNumber,
      "observations": observations,
    }
  }
}
